export const phoneRegex = /^(\()?[2-9]{1}\d{2}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/gim;

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gim;

export const zipCode = /^\d{5}(?:[-\s]\d{4})?$/gim;

export const goalRegex = /^\d+$/;

export const urlRegex = /^https?:\/\//;
